module.exports = __webpack_public_path__ + "static/media/photo-upload.ff0e7844.png";